<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import axios from 'axios';

    export default {
        props: {
            value: [String, Number, Array],
            label: String,
            labelWidth: String,
            field: String,
            withAll: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            add: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                //val: '',
                //newList: [],
                options:[],
            }
        },
        methods: {
            //...mapActions('dictionaries/ownerLegal/select', {
            //    get: 'get',
            //}),
            change_value(v) {

                this.$emit('input', v);
                this.$emit('change', v);
            },
            input_value(v) {
                this.$emit('input', v);
            },
            item_add() {
                //                this.$dialog('dictionaries_cash_item', {})
            },

            loadManagerData() {
                axios({
                    method: 'get',
                    url: '/tourclient/api/giftcertificate/managers',
                }).then(({data}) => {
                    if(!data.ResultQueryInfo.HasError){
                        this.options = data.Managers.map((item) => {
                            return {
                                value : item.Id,
                                label : item.Name,
                            }
                        })
                    }
                    else {
                        //TODO
                    }
                });
                // }).catch(e => {
                //     context.dispatch('error', e, {root: true});
                // });
            },
        },
        computed: {
            //...mapGetters('dictionaries/ownerLegal/select', {
            //    list_getters: 'list',
            //    list_all_getters: 'list_with_all',
            //}),
            //list() {
            //    debugger;
            //    return (this.withAll?this.list_all_getters:this.list_getters).filter(i=>i.value===0||i.active||i.value===this.value);
            //},

            append() {
                return this.show_add || this.show_remove;
            },
            show_add() {
                if (this.disabled) return false;
                return this.add;
            },
            show_remove() {
                if (this.disabled) return false;
                if (!this.multiple) return false;
                if (this.value && !this.value.length) {
                    return false;
                }
                return true;
            },
        },
        watch: {},
        mounted() {
            this.loadManagerData();
        },

        components: {},
    }
</script>
<template>
    <form-group class="dictionary dictionary-owner-legal" :label-width="labelWidth" :append="append" :label="label">
        <el-select :value="value"
                   @change="$emit('change', $event)"
                   @input="$emit('input', $event)"
                   :disabled="disabled"
                   :filterable="filterable"
                   :multiple="multiple"
                   :collapse-tags="multiple"
                   :clearable="clearable">
            <el-option
                v-for="item in options"
                :key="item.value"
                :value="item.value"
                :label="item.label"
            />
        </el-select>
        <el-button v-if="show_remove"
                   slot="append"
                   icon="el-icon-close"
                   title="Очистить"
                   @click="change_value('')">
        </el-button>
        <el-button v-if="show_add"
                   slot="append"
                   icon="el-icon-plus"
                   title="Добавить"
                   @click="item_add">
        </el-button>
    </form-group>
</template>
<style lang="scss">

    .table .el-table td .cell {
        padding: 2px 10px;
        height: 32px;
    }

    .table.checked .el-table__row.is-error {
        background: #f56c6c !important;
        &:hover{
            background: #f56c6c !important;
        }

        .table__button {
            margin-top: 3px;
        }
    }
</style>
